import { defineStore } from 'pinia'

export type VariableType = 'Text' | 'Number' | 'E-mail' | 'Date' | 'DateTime' | 'Phone' | 'Dropdown'

export type VariableMetadata = {
  type: VariableType
  defaultValue?: string
  dateFormat?: string
  dropdownOptions?: string[]
}

export type VariableTypeState = {
  variableMetadata: Map<string, VariableMetadata>
}

// Helper function to normalize variable name key (case-insensitive)
function normalizeKey(name: string): string {
  return name.toLowerCase().trim()
}

export const useVariableTypeStore = defineStore('variableType', {
  state: (): VariableTypeState => ({
    variableMetadata: new Map()
  }),
  actions: {
    setVariableMetadata(name: string, type: VariableType, defaultValue?: string, dateFormat?: string) {
      this.variableMetadata.set(normalizeKey(name), { type, defaultValue, dateFormat })
    },
    getVariableMetadata(name: string): VariableMetadata | undefined {
      return this.variableMetadata.get(normalizeKey(name))
    },
    getVariableType(name: string): VariableType | undefined {
      return this.getVariableMetadata(name)?.type
    },
    getVariableDefaultValue(name: string): string | undefined {
      return this.getVariableMetadata(name)?.defaultValue
    },
    hasVariableType(name: string): boolean {
      return this.variableMetadata.has(normalizeKey(name))
    },
    clearVariableType(name: string) {
      this.variableMetadata.delete(normalizeKey(name))
    },
    clearAll() {
      this.variableMetadata.clear()
    }
  }
})

export type VariableTypeStore = ReturnType<typeof useVariableTypeStore>
